import { ContextualMenuPopper, LayoutGrid, makeStyles } from '@archer-technologies/ui-components';
import { DataTypeProvider, DataTypeProviderProps } from '@devexpress/dx-react-grid';
import * as React from 'react';

const useStyles = makeStyles(() => {
  return {
    checkCellStyles: {
      margin: '-7px 0'
    }
  };
});

const ActionsFormatter = ({ value }: DataTypeProvider.ValueFormatterProps) => {
  const { checkCellStyles } = useStyles();

  return value ? (
    <LayoutGrid className={checkCellStyles}>
      <ContextualMenuPopper {...value} />
    </LayoutGrid>
  ) : null;
};

const ActionTypeProvider = (props: DataTypeProviderProps) => <DataTypeProvider formatterComponent={ActionsFormatter} {...props} />;

export { ActionTypeProvider, ActionsFormatter };
